import { mapDTO } from '@twistezo/ts-dto-mapper'

import { TransferListItem } from 'components/Form/TransferList'
import { AdUnitDTO } from 'features/inventory/api/types/adUnitDTO'
import { domainFromDTO } from 'features/inventory/mappers/domain'
import { adUnitForTransferListFromDTO } from 'features/inventory/page/forms/GeneralForm/hooks/useGetAdUnitsForPageTransferList/api/mapper'
import { PageForGeneralForm } from '../types'
import { PageSliceDTO } from './types'

export const pageForGeneralFormFromDTO = (from: PageSliceDTO): PageForGeneralForm =>
  mapDTO<PageSliceDTO, PageForGeneralForm>({ from }).transform(pageDTO => ({
    ...pageDTO,
    adUnits: pageDTO.adUnits
      .map((adUnit: AdUnitDTO): TransferListItem => adUnitForTransferListFromDTO(adUnit))
      .toSorted((a: TransferListItem, b: TransferListItem): number =>
        a.value.toLowerCase().localeCompare(b.value.toLowerCase()),
      ),
    domain: domainFromDTO(pageDTO.domain),
  }))
